<script lang="ts">
    import { getContext } from 'svelte'
    import { derived as sderived } from 'svelte/store'

    import Icon from '@iconify/svelte'

    import { gettext as _, ngettext } from 'hydria/services/gettext'
    import { sanchor, spath } from 'hydria/svelte_helpers'

    import type { DomainHandler } from './domain'

    const Domain = getContext('Domain') as DomainHandler
    const status = sderived(Domain.status, ($status) => $status)

    let delegates = $derived(sderived(Domain.delegates, ($v) => $v))
</script>

<div class="card domain-delegates">
    <div class="card-title text-primary">{$ngettext('Délégué avec accès', 'Délégués avec accès', { n: $delegates ? $delegates.length : 0 })}</div>
    {#if $status != 'ready'}
        <div class="card-body"><div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div></div>
    {:else if $delegates && $delegates.length}
        <div class="card-body">
            <div class="dom-delegate-list">
                <div class="ddl-row head">
                    <div class="name">Nom</div>
                    <div class="email">Email</div>
                    <div class="technical">Tech</div>
                    <div class="renewal">Renew</div>
                </div>
                <div class="ddl-rows">
                    {#each $delegates as delegate (delegate.id)}
                        <div class="ddl-row">
                            <div class="name"><a use:sanchor href={spath(`/wdom-user/${delegate.id}`)}>{delegate.visual}</a></div>
                            <div class="email">{delegate.email}</div>
                            <div class="technical">
                                {#if delegate.technical}<Icon inline icon="mdi:check" />{/if}
                            </div>
                            <div class="renewal">
                                {#if delegate.renewal}<Icon inline icon="mdi:check" />{/if}
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    {:else}
        <div class="card-body">Aucun délégué.</div>
    {/if}
</div>
